export default IconPray => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-pray" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
  <path d="M7 20h8l-4 -4v-7l4 3l2 -2" />
</svg>`;